import { BaseResponse } from './../common/BaseResponse';
import { OrderId } from './OrderResponse';
import { PurchaseOrderId } from './PurchaseOrderResponse';
export type OrderShipmentId = string;

export enum OrderShipmentStatus {
  acknowledged = 'acknowledged',
  shipped = 'shipped',
  opened = 'opened',
  delivered = 'delivered',
}

export interface OrderShipmentResponse extends BaseResponse {
  id: OrderShipmentId;
  orderId: OrderId;
  poId: PurchaseOrderId;
  status: OrderShipmentStatus;
  amount: number;
  items: OrderShipmentLineItem[];
  shippingMethod: string;
  shippingAccountNo: string;
  trackId: string;
  deliveryDate?: number;
  shippedDate?: number;
  printUrl: string;
}

export interface OrderShipmentLineItem {
  id: number;
  poLineId: number;
  shipmentId: number;
}

export interface OrderShipmentRequest extends OrderShipmentResponse {
  lines: string[];
}
